"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Converts strings to primitive values if possible
// Eg '5' -> 5, 'true' -> true, 'string' -> 'string'
function coerce(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
}

var _default = coerce;
exports["default"] = _default;